module.exports = {"350722001":"南浦街道","350722002":"河滨街道","350722101":"富岭镇","350722102":"石陂镇","350722103":"临江镇","350722104":"仙阳镇","350722105":"水北街镇","350722106":"永兴镇","350722107":"忠信镇","350722108":"莲塘镇","350722109":"九牧镇","350722200":"万安乡","350722201":"古楼乡","350722202":"山下乡","350722203":"枫溪乡","350722204":"濠村乡","350722205":"管厝乡","350722206":"盘亭乡","350722207":"官路乡","350722400":"水南农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350722.json
// module id = 1223
// module chunks = 0